import { createFileRoute } from '@tanstack/react-router'
import { useEffect, useState } from 'react'

// Déclarations globales pour GA4 et Meta Pixel
declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
    fbq?: (...args: unknown[]) => void
  }
}

function RegistrationConfirmation() {
  const [countdown, setCountdown] = useState(5)

  useEffect(() => {
    // Tracking des conversions sur la page de confirmation
    // Facebook Pixel Lead event
    // Google Analytics Lead event
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'lead', {
        event_category: 'Registration Confirmation',
        event_label: 'Inscription gratuite confirmée',
        value: 0,
        currency: 'EUR',
      })

      // Google Ads Conversion event (selon les instructions reçues)
      window.gtag('event', 'conversion', {
        send_to: 'AW-16835514329/N_nTCKD25aQbENmf5ts-',
      })
    }

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          window.location.href = '/onboarding'
          return 0
        }
        return prev - 1
      })
    }, 1000)
    return () => {
      clearInterval(timer)
    }
  }, [])

  return (
    <div className="bg-gray-25 flex min-h-screen items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="shadow-custom flex flex-col gap-8 rounded-2xl border border-gray-100 bg-white p-8">
          {/* Logo */}
          <div className="mb-2 flex justify-center">
            <img src="/logos/viastud-logo.svg" alt="Viastud" className="h-10" />
          </div>

          {/* Headline */}
          <div className="mb-2 flex flex-col gap-y-0.5 text-center">
            <h1 className="mb-3 text-2xl font-bold text-gray-950">Bienvenue chez Viastud !</h1>
            <div>Un membre de notre équipe vous contactera prochainement.</div>
            <div>L&#39;équipe Viastud.</div>
          </div>

          {/* Redirect Notice */}
          <div className="mt-2 text-center">
            <span className="text-sm text-gray-600">Redirection dans {countdown}s...</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export const Route = createFileRoute('/registration-confirmation')({
  component: RegistrationConfirmation,
})
